import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { loadWorkshopEnrolments } from './actions';
import { getChild } from '../reducer';
import List from './List';
import Grid from './Grid';
import ui from '../../common/services/ui';

class WorkshopEnrolments extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		this.props.loadWorkshopEnrolments(this.props.pagination);
	}

	handleListEvent(listPagination) {
		this.props.loadWorkshopEnrolments(listPagination);
	}

	render() {
		const { data, pagination } = this.props;

		return <div>
			{ui.isMobileView ? <Grid data={data} onFetchData={this.handleListEvent} {...pagination} /> :
				<List data={data} onFetchData={this.handleListEvent} {...pagination} />}
		</div>;
	}
}

const mapStateToProps = state => {
	const { parent, entities: { workshopEnrolments, centers }, pagination } = state;

	const workshopEnrolmentsPagination = pagination.workshopEnrolments.all || { ids: [], pageNumber: 1, pageSize: 10 };

	const visibleEnrolments = workshopEnrolmentsPagination.ids.map(id => workshopEnrolments[id]);
	visibleEnrolments.forEach(enrolment => {
		if (enrolment) {
			enrolment.child = getChild(parent, enrolment.childId);	
			enrolment.center = centers[enrolment.centerId];
		}
	});

	return {
		data: visibleEnrolments,
		pagination: workshopEnrolmentsPagination
	};
};

export default connect(mapStateToProps, {
	loadWorkshopEnrolments
})(withTranslation()(WorkshopEnrolments));